import { push } from 'react-router-redux';
import { call, put, select } from 'redux-saga/effects';

import * as Actions from '../../../actions';
import { getInDomain } from '../../../domains/externalUtils';
import * as RouterUtils from '../../../lib/RouterUtils';
import { putAndWait } from '../../../sagas/TaskManager';
import { getStore } from '../../../store/StoreAccessor';
import Logger from '../../../tools/Logger';
import * as Utils from '../../../utils';

const log = Logger.child({
  component: 'mediator/resetPasswordAndReauth',
});

export function* handlePostAuth() {
  // check to see if the next path is the same as this one as the hash should be dropped if the new location isn't the same as the current
  let nextPath = yield select(Utils.Route.getNextPath, false);
  if (nextPath === window.location.pathname && window.location.hash) {
    nextPath += window.location.hash;
  }

  // if playback enabled and listener is logged in (anon first time or registered listener) start playback
  const isLoggedIn = yield select(Utils.Listener.isLoggedIn);
  const isPlaybackEnabled = yield select(Utils.Capabilities.isPlaybackEnabled);
  if (isPlaybackEnabled && isLoggedIn) {
    const routeParams = yield call(RouterUtils.getRouterParams, getStore());
    yield put(getInDomain('playback.actions.initializePlayback')(routeParams));
  }

  // clear post auth redirect
  yield put(Actions.Login.loginFlowComplete());

  // redirect to post auth path
  yield put(push(nextPath));
}

export function* resetPasswordAndReauth({ payload }) {
  const loginData = {
    captcha: payload.captchaState,
    isUserInitiated: true,
    password: payload.newPassword,
    router: payload.router,
    username: payload.username,
  };
  try {
    yield call(putAndWait, Actions.Login.resetUserPassword(payload));

    const loginErrorKey = yield select(
      getInDomain('listener.selectors.auth.getLoginErrorKey', null),
    );
    if (!loginErrorKey) {
      yield call(putAndWait, Actions.Login.authenticateListener(loginData));
      yield call(handlePostAuth);
    }
  } catch (err) {
    log.error(
      {
        obj: err,
      },
      'resetPasswordAndReauth(): unable to reset password',
    );
  }
}
